import { useCallback, useState } from "react";
import {
  AndamentoApartamento,
  buscarAndamentosApartamentoService,
} from "../../../services/buscarAndamentosApartamentoService";

export const useBuscarAndamentosApartamento = () => {
  const [andamentos, setAndamentos] = useState<AndamentoApartamento[]>([]);
  const [loading, setLoading] = useState(false);

  const buscar = useCallback(async (apartamentoId: number) => {
    if (!apartamentoId) return;

    setLoading(true);
    try {
      const dados = await buscarAndamentosApartamentoService(apartamentoId);
      setAndamentos(dados);
    } catch (error) {
      console.error("Erro ao buscar andamentos do apartamento:", error);
      setAndamentos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    andamentos,
    loading,
    buscar,
  };
};
